import React from "react";
import ReactDOM from "react-dom/client";
import Unit from "./unit.jsx";

class UnitsApp extends React.Component {
  unitList = document.querySelector("#rental-unit-list");

  constructor(props) {
    super(props);
    this.addUnit = this.addUnit.bind(this);
    this.removeUnit = this.removeUnit.bind(this);
    this.prefix = rentalUnitListContainer.dataset.prefix || "";
    this.fieldName = rentalUnitListContainer.dataset.fieldName || "units";
    this.unitMax = rentalUnitListContainer.dataset.unitMax || 50;
    this.rentalUnits = rentalUnitListContainer.dataset.units || [];
    this.csrfToken = rentalUnitListContainer.dataset.csrfToken || "";
    this.fields = {
      id: [],
      price: [],
      type: [],
      deposit: [],
      cleaning: [],
      period_min: [],
      size: [],
      capacity: [],
      capacity_extra: [],
      count: [],
    };
    this.childrenFields = [
      "extras",
      "discounts",
      "taglines",
      "descriptions",
      "rooms",
      "picture_selection",
      "equipments",
    ];
    let self = this;
    Object.keys(self.fields).forEach((field) => {
      self.fields[field]["form"] = $(rentalUnitsPrototype).find(
        "#" + self.prefix + "_" + self.fieldName + "___name___" + field
      );
      self.fields[field]["label"] = $(rentalUnitsPrototype).find(
        'label[for="' +
          self.prefix +
          "_" +
          self.fieldName +
          "___name___" +
          field +
          '"]'
      );
    });

    this.state = {
      units: [],
      key: 0,
    };
  }

  removeUnit(unit) {
    // var self = this
    let unitList = document.querySelector("#rental-unit-list");
    let rentalId = unitList.getAttribute("data-id");
    let deleteable = false;
    let message = "";

    if (unit.db_id !== undefined) {
      let promise = new Promise((resolve, reject) => {
        console.log("calendar delete");
        window
          .fetch("/admin/de/rental/calendar/" + rentalId + "/" + unit.db_id, {
            method: "DELETE", // *GET, POST, PUT, DELETE, etc.
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          })
          .then((res) => res.json())
          .then(
            (result) => {
              deleteable = result.code !== 400;
              console.log(result);
              if (deleteable) {
                resolve(result);
              } else {
                reject(
                  window.Translator.trans("units.no.delete", {}, "js") ||
                    result.message
                );
              }
            },
            (error) => {
              reject(error);
            }
          );
      });

      promise
        .then(() => {
          console.log("unit delete");
          window
            .fetch("/admin/de/rental/units/" + rentalId + "/" + unit.db_id, {
              method: "DELETE", // *GET, POST, PUT, DELETE, etc.
              headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": this.csrfToken,
              },
            })
            .then((res) => res.json())
            .then((result) => {
              if (!result.success) throw new Error(result.message);

              this.setState({
                units: this.state.units.filter((el) => el.key !== unit.key),
              });
            })
            .catch((error) => {
              alert(error);
            });
        })
        .catch((error) => {
          alert(error);
        });
    } else {
      this.setState({
        units: this.state.units.filter((el) => el.key !== unit.key),
      });
    }
  }

  addUnit() {
    let self = this;
    let newUnit = {};
    Object.keys(self.fields).forEach((key) => {
      let form = self.fields[key]["form"]
        .clone()
        .addClass("mdc-text-field__input")
        .wrap("<helper>")
        .parent()
        .html()
        .replace(/__name__/g, self.state.key)
        .trim();
      var template = document.createElement("template");
      template.innerHTML = form;
      newUnit[key] = {
        form: form.replace("value", "defaultValue"),
        class: template.content.firstChild.getAttribute("class"),
        value: template.content.firstChild.getAttribute("value"),
        name: template.content.firstChild.getAttribute("name"),
        min: template.content.firstChild.getAttribute("min"),
        required: template.content.firstChild.getAttribute("required"),
        id: template.content.firstChild.getAttribute("id"),
        type:
          template.content.firstChild.getAttribute("type") ||
          template.content.firstChild.tagName.toLowerCase(),
        label: (
          self.fields[key]["label"]
            .clone()
            .addClass("mdc-floating-label mdc-floating-label--float-above")
            .wrap("<helper>")
            .parent()
            .html() || ""
        ).replace(/__name__/g, self.state.key),
      };
      if (newUnit[key].type == "select") {
        newUnit[key].options = [];
        self.fields[key]["form"].find("option").each((index, option) => {
          newUnit[key].options.push({
            value: option.value,
            label: option.label,
          });
        });
      }
    });
    let equipments =
      JSON.parse(rentalUnitListContainer.dataset.equipments) || [];

    newUnit["equipments"] = equipments
      .filter((el) => el.checked == true)
      .map((el) => el.id);
    newUnit["key"] = self.state.key;
    let units = this.state.units;
    Array.prototype.push.apply(units, [newUnit]);

    self.setState({
      units: units,
      key: ++self.state.key,
    });
    //.replace(/__name__/g, newUnit.key)
  }

  importUnit(unit) {
    let self = this;
    let importedUnit = {};
    Object.keys(self.fields).forEach((key) => {
      let form = self.fields[key]["form"]
        .clone()
        .addClass("mdc-text-field__input")
        .wrap("<helper>")
        .parent()
        .html()
        .replace(/__name__/g, self.state.key)
        .trim();
      var template = document.createElement("template");
      template.innerHTML = form;
      importedUnit[key] = {
        form: form.replace("value", "defaultValue"),
        class: template.content.firstChild.getAttribute("class"),
        value: unit[key],
        name: template.content.firstChild.getAttribute("name"),
        min: template.content.firstChild.getAttribute("min"),
        required: template.content.firstChild.getAttribute("required"),
        id: template.content.firstChild.getAttribute("id"),
        type:
          template.content.firstChild.getAttribute("type") ||
          template.content.firstChild.tagName.toLowerCase(),
        label: (
          self.fields[key]["label"]
            .clone()
            .addClass("mdc-floating-label mdc-floating-label--float-above")
            .wrap("<helper>")
            .parent()
            .html() || ""
        ).replace(/__name__/g, self.state.key),
      };
      if (importedUnit[key].type == "select") {
        importedUnit[key].options = [];
        self.fields[key]["form"].find("option").each((index, option) => {
          importedUnit[key].options.push({
            value: option.value,
            label: option.label,
          });
        });
      }
    });
    self.childrenFields.forEach((field) => {
      if (
        typeof unit[field] !== "undefined" &&
        Object.keys(unit[field]).length > 0
      ) {
        importedUnit[field] = unit[field];
      }
    });

    importedUnit["key"] = self.state.key;
    importedUnit["db_id"] = unit["id"];
    let units = this.state.units;
    Array.prototype.push.apply(units, [importedUnit]);

    self.setState({
      units: units,
      key: ++self.state.key,
    });
  }

  componentDidMount() {
    var self = this;
    JSON.parse(self.rentalUnits).forEach((unit) => {
      self.importUnit(unit);
    });
  }

  render() {
    let self = this;
    let addUnitBtn = (
      <button
        type="button"
        onClick={this.addUnit}
        className="add-unit small btn btn--primary btn--ss strong mt-1"
      >
        <svg className="icon new" width="16" height="16">
          <use href="#new"></use>
        </svg>
        {window.Translator.trans("units.buttons.add.units", {}, "js")}
      </button>
    );

    let defaultHint = (
      <p className="empty-hint">
        {window.Translator.trans("units.empty", {}, "js")}
      </p>
    );

    return (
      <>
        <label className="h6">
          <svg className="icon house me-1" width="16" height="16">
            <use href="#house"></use>
          </svg>
          {window.Translator.trans("units.headline", {}, "js")}
        </label>

        {this.state.units.length > 0
          ? this.state.units.map((unit, index) => (
              // <div key={unit.key+'-'+index}>
              <Unit
                key={unit.key}
                unit={unit}
                index={unit.key}
                dataset={rentalUnitListContainer.dataset}
                removeUnit={this.removeUnit}
              />
              // </div>
            ))
          : ""}

        {this.state.units.length > 0 ? "" : defaultHint}
        {this.state.units.length < this.unitMax ? addUnitBtn : ""}
      </>
    );
  }
}

let rentalUnitListContainer = null;
if (
  document.querySelector("#rental-edit") !== null &&
  document.querySelector("#rental-edit").dataset.id !== null &&
  (rentalUnitListContainer = document.querySelector("#rental-unit-list")) !==
    null
) {
  const rentalUnitListContainerRoot = ReactDOM.createRoot(
    rentalUnitListContainer
  );
  rentalUnitListContainerRoot.render(<UnitsApp />);
}
